export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /home/pentarchcom/public_html/website/web/app/themes/main-theme/resources/assets/scripts/routes/home.js